import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import IconButton from '@mui/material/IconButton';
import InputLabel from '@mui/material/InputLabel';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import FacebookIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import TwitterIcon from '@mui/icons-material/X';
import EmailModal from './EmailModal';

function Copyright() {
    return (
        <Typography variant="body2" sx={{
            color: 'text.secondary', mt: 1, fontFamily: 'sans-serif', // Minimalistic font
        }}>
            {'Copyright © '}
            <Link color="text.secondary" href="https://mui.com/">
                refrb
            </Link>
            &nbsp;
            {new Date().getFullYear()}
        </Typography>
    );
}

export default function Footer() {
    const [isModalOpen, setIsModalOpen] = React.useState(false); // State for managing modal open/close
    const handleModalOpen = () => setIsModalOpen(true); // Open the modal
    const handleModalClose = () => setIsModalOpen(false); // Close the modal

    return (
        <Container
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: { xs: 4, sm: 8 },
                py: { xs: 8, sm: 10 },
                textAlign: { sm: 'center', md: 'left' },
                fontFamily: 'sans-serif', // Minimalistic font

            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: { xs: 'column', sm: 'row' },
                    width: '100%',
                    justifyContent: 'space-between',
                    fontFamily: 'sans-serif', // Minimalistic font

                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 4,
                        minWidth: { xs: '100%', sm: '60%' },
                        fontFamily: 'sans-serif', // Minimalistic font

                    }}
                >
                    <Box sx={{ width: { xs: '100%', sm: '60%' } }}>
                        <Typography variant="body2" gutterBottom sx={{
                            fontWeight: 600, mt: 2, fontFamily: 'sans-serif', // Minimalistic font
                        }}>
                            Want to reach out?
                        </Typography>
                        <Typography variant="body2" sx={{
                            color: 'text.secondary', mb: 2, fontFamily: 'sans-serif', // Minimalistic font
                        }}>
                            Send us an email if you've got some inventory to get rid of
                        </Typography>
                        <InputLabel htmlFor="email-newsletter">Email</InputLabel>
                        <Stack direction="row" spacing={1} useFlexGap>
                            <TextField
                                id="email-newsletter"
                                hiddenLabel
                                size="small"
                                variant="outlined"
                                fullWidth
                                aria-label="Enter your email address"
                                placeholder="Your email address"
                                slotProps={{
                                    htmlInput: {
                                        autoComplete: 'off',
                                        'aria-label': 'Enter your email address',
                                    },
                                }}
                                sx={{
                                    width: '250px', fontFamily: 'sans-serif', // Minimalistic font
                                }}
                            />
                            <EmailModal open={isModalOpen} onClose={handleModalClose} />

                        </Stack>
                    </Box>
                </Box>
            </Box>
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    pt: { xs: 4, sm: 8 },
                    width: '100%',
                    borderTop: '1px solid',
                    borderColor: 'divider',
                    fontFamily: 'sans-serif', // Minimalistic font

                }}
            >
                <Stack
                    direction="row"
                    spacing={1}
                    useFlexGap
                    sx={{
                        justifyContent: 'left', color: 'text.secondary', fontFamily: 'sans-serif', // Minimalistic font
                    }}
                >
                    <IconButton
                        color="inherit"
                        size="small"
                        href="https://github.com/lameburger"
                        aria-label="GitHub"
                        sx={{
                            alignSelf: 'center', fontFamily: 'sans-serif', // Minimalistic font
                        }}
                    >
                        <FacebookIcon />
                    </IconButton>
                    <IconButton
                        color="inherit"
                        size="small"
                        href="https://www.linkedin.com/in/laneburgett/"
                        aria-label="LinkedIn"
                        sx={{
                            alignSelf: 'center', fontFamily: 'sans-serif', // Minimalistic font
                        }}
                    >
                        <LinkedInIcon />
                    </IconButton>
                </Stack>
            </Box>
        </Container>
    );
}